module.exports = __webpack_public_path__ + "static/media/XML.efc3b156.jpg";